var Chart = require('chart.js');

module.exports = {
	config: {
		chartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
				},
				tooltips: {
					// enabled: false
				},
				// animation: {
				// 	duration: 0 // general animation time
				// },
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 65,
				rotation: -1.125 * Math.PI,
				circumference: 1.25 * Math.PI,
				// maintainAspectRatio: false,
				aspectRatio: 1,
				// responsive: false,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		}
	},

	model: {
		chartProperties: {},
		title: 'UNDEFINED',
		value: '0.00 %',
		footer: '...',
	},

	methods: {
		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .overlay > .canvasContainer > canvas'), this.model.chartProperties);
			}
		}
	},

	hooks: {
		update: function($element, options) {
			var self = this;

			this.initChart();

			if(self.model.chart && options.mailingResourceData){
				var mailingAttributes = options.mailingResourceData.attributes || {};
				var stats = mailingAttributes.stats || {};
				var type = (self.model.type || {}).data || 'received';

				var value 	= 0;
				var overall	= 0;
				if(type === 'received'){
					value 	= stats.sent || 0;
					overall = mailingAttributes.statsRecipients || stats.all || 0;
				} else if (type === 'views') {
					value 	= stats.uniqueSubscriberViews || 0;
					overall = stats.sent || mailingAttributes.statsRecipients || stats.all || 0;
				} else if (type === 'clicks') {
					value 	= mailingAttributes.nrOfClickSubscribers || 0;
					overall = stats.sent || mailingAttributes.statsRecipients || stats.all || 0;
				} else if (type === 'unsubscribed') {
					value 	= mailingAttributes.statsUnsubscribed || 0;
					overall = stats.sent || mailingAttributes.statsRecipients || stats.all || 0;
				}

				if(overall > 0){
					self.model.chart.data.labels = [
						self.model.title,
						'Andere'
					];
					self.model.value = `${parseFloat(value * 100 / overall).toFixed(1)} %`.replace('.', ',');
					self.model.footer = `${value} / ${overall}`;
					self.model.chart.data.datasets[0].data = [value, overall - value];
				} else {
					self.model.chart.data.labels = [];
					self.model.chart.data.datasets[0].data = [];
				}

				self.refresh(false, { updateChart: true });
			}
		},

		attach: function($element, options){
			var self = this;

			if(options.updateChart){
				self.model.chart.destroy();
				delete self.model.chart;
				self.initChart();
				self.model.chart.update();
			} else {

				// in case of refreshes the chart-dom-binding has to be renewed
				if (self.model.chart && (options || {}).refresh){
					self.model.chart.destroy();
					delete self.model.chart;
				}
				if(!self.model.chart){
					self.model.chartProperties = self.config.chartProperties;

					var type = (self.model.type || {}).data || 'received';

					self.model.title 			= 'UNKWNOWN';
					self.model.primaryColor		= '#666666'
					self.model.secondaryColor	= '#888888'
					if(type === 'received'){
						self.model.title 		= 'Zugestellt';
						self.model.primaryColor	= '#006600'
					} else if (type === 'views') {
						self.model.title 		= 'Gelesen';
						self.model.primaryColor	= '#ECCB00'
					} else if (type === 'clicks') {
						self.model.title 		= 'Klicks';
						self.model.primaryColor	= '#F3860A'
					} else if (type === 'unsubscribed') {
						self.model.title 		= 'Abgemeldet';
						self.model.primaryColor	= '#3076B2'
					}


					self.model.chartProperties.data = {
						datasets: [{
							data: [],
							backgroundColor: [
								self.model.primaryColor,
								self.model.secondaryColor,
							],
							hoverBackgroundColor: [
								self.model.primaryColor,
								self.model.secondaryColor,
							],
							borderColor: [
								'#F9F9F9',
								'#F9F9F9',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						}]
					};
					self.initChart();
				}
			}
		}
	}
};
